// Přepínač tmavá/světlá — ikonka slunce/měsíce, sedí na každé obrazovce.
// V horní liště jako .thmbtn; na obrazovkách bez lišty s prop float
// (plovoucí vpravo nahoře). Volba drží v localStorage (lib/useTheme).

import { toggleTheme, useTheme } from "../lib/useTheme";

export function ThemeToggle({ float = false }: { float?: boolean }) {
  const mode = useTheme();
  return (
    <button
      className={`thmbtn${float ? " float" : ""}`}
      onClick={toggleTheme}
      aria-label="Přepnout tmavý/světlý režim"
    >
      {mode === "light" ? (
        // měsíc = ťuknutím zpět do tmavé
        <svg viewBox="0 0 24 24">
          <path d="M20 13A8 8 0 1 1 11 4a6.5 6.5 0 0 0 9 9z" />
        </svg>
      ) : (
        // slunce = ťuknutím do světlé
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      )}
    </button>
  );
}
